(ns app.front.view.group.admin.inspections.inspection-labels
  (:require [app.domain.label.model :as label-model]
            [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.ui.label-group :as label-ui]
            [app.front.ui.label-group-state :as label-group-state]
            [app.front.util :refer [for-frag]]
            [app.front.view.common.label-file-transfer :as label-file-transfer]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.subs :as gas]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))

(rf/reg-event-fx ::create-label-group
  (fn [_ [_ authority-group-id name]]
    {:dispatch [:comm/command-monitored {:command    :inspection/create-label-group
                                         :method     :post
                                         :data       {:authority-group-id authority-group-id
                                                      :name               name}
                                         :on-success [::create-label-group.success]
                                         :notify     {:success :changes-saved}}]}))

(rf/reg-event-fx ::create-label-group.success
  (fn [_ [_ status response]]
    {:dispatch-n [[::entities/apply-changes status response]
                  [::label-group-state/cancel-adding-group]]}))

(rf/reg-event-fx ::edit-label-group
  (fn [_ [_ label-group-id name]]
    {:dispatch [:comm/command-monitored {:command    :inspection/edit-label-group
                                         :method     :post
                                         :data       {:label-group-id label-group-id
                                                      :name           name}
                                         :on-success [::edit-label-group.success]
                                         :notify     {:success :changes-saved}}]}))

(rf/reg-event-fx ::edit-label-group.success
  (fn [_ [_ status response]]
    {:dispatch-n [[::entities/apply-changes status response]
                  [::label-group-state/cancel-editing-group]]}))

(rf/reg-event-fx ::delete-label-group
  (fn [_ [_ label-group-id]]
    {:dispatch [:comm/command-monitored {:command    :inspection/delete-label-group
                                         :method     :post
                                         :data       {:label-group-id label-group-id}
                                         :on-success [::entities/apply-changes]
                                         :notify     {:success :changes-saved}}]}))

(rf/reg-event-fx ::create-label
  (fn [_ [_ label-group-id name]]
    {:dispatch [:comm/command-monitored {:command    :inspection/create-label
                                         :method     :post
                                         :data       {:label-group-id label-group-id
                                                      :name           name}
                                         :on-success [::create-label.success label-group-id]
                                         :notify     {:success :changes-saved}}]}))

(rf/reg-event-fx ::create-label.success
  (fn [_ [_ label-group-id status response]]
    {:dispatch-n [[::entities/apply-changes status response]
                  [::label-group-state/clear-new-label-input label-group-id]]}))

(rf/reg-event-fx ::edit-label
  (fn [_ [_ label-id name]]
    {:dispatch [:comm/command-monitored {:command    :inspection/edit-label
                                         :method     :post
                                         :data       {:label-id label-id
                                                      :name     name}
                                         :on-success [::edit-label.success]
                                         :notify     {:success :changes-saved}}]}))

(rf/reg-event-fx ::edit-label.success
  (fn [_ [_ status response]]
    {:dispatch-n [[::entities/apply-changes status response]
                  [::label-group-state/cancel-editing-label]]}))

(rf/reg-event-fx ::delete-label
  (fn [_ [_ label-id]]
    {:dispatch [:comm/command-monitored {:command    :inspection/delete-label
                                         :method     :post
                                         :data       {:label-id label-id}
                                         :on-success [::entities/apply-changes]
                                         :notify     {:success :changes-saved}}]}))

;;; =============================================================================
;;; Connected Components - Wire UI to State
;;; =============================================================================

(defn new-label-input-connected
  "New label input connected to re-frame state.
   Accepts :existing-names (sibling label names) so the shared component blocks duplicate labels."
  [{:keys [tr group-id existing-names]}]
  (let [value         (<sub [::label-group-state/new-label-name group-id])
        focused?      (<sub [::label-group-state/input-focused? group-id])
        show-buttons? (or focused? (seq value))]
    [label-ui/new-label-input
     {:id             (str "new-label-input-" group-id)
      :tr             tr
      :value          value
      :existing-names existing-names
      :show-buttons?  show-buttons?
      :on-change      #(>evt [::label-group-state/set-new-label-name group-id %])
      :on-focus       #(>evt [::label-group-state/set-input-focused group-id true])
      :on-blur        #(>evt [::label-group-state/set-input-focused group-id false])
      :on-save        #(>evt [::create-label group-id value])
      :on-cancel      #(>evt [::label-group-state/set-new-label-name group-id ""])}]))

(defn- deletable-label-chip
  "Label chip with delete confirmation modal"
  [{:keys [tr label-entity existing-names]}]
  (r/with-let [*show-delete-modal? (r/atom false)]
    (let [label-id     (:db/id label-entity)
          label-name   (label-model/label-name label-entity)
          editing-id   (<sub [::label-group-state/editing-label-id])
          editing?     (= editing-id label-id)
          editing-name (<sub [::label-group-state/editing-label-name])]
      [:<>
       [ui/confirm-modal
        {:open?        @*show-delete-modal?
         :tr           tr
         :id           (str "delete-label-" label-id)
         :on-yes-click (fn []
                         (>evt [::delete-label label-id])
                         (reset! *show-delete-modal? false))
         :on-close     #(reset! *show-delete-modal? false)}
        (tr [:labels/confirm-delete-label])]
       [label-ui/label-chip
        {:tr             tr
         :label          {:id label-id :name label-name}
         :editing?       editing?
         :editing-name   editing-name
         :existing-names existing-names
         :current-id     label-id
         :on-click       #(>evt [::label-group-state/set-editing-label label-id label-name])
         :on-change      #(>evt [::label-group-state/set-editing-label-name %])
         :on-save        #(>evt [::edit-label label-id editing-name])
         :on-cancel      #(>evt [::label-group-state/cancel-editing-label])
         :on-delete      #(reset! *show-delete-modal? true)}]])))

(defn label-group-section
  "A collapsible section for a label group"
  [{:keys [tr group-entity]}]
  (r/with-let [*show-delete-group-modal? (r/atom false)]
    (let [group-id       (:db/id group-entity)
          group-name     (label-model/label-group-name group-entity)
          labels         (label-model/active-labels group-entity)
          existing-names (into {} (map (juxt label-model/label-name :db/id)) labels)
          expanded?      (<sub [::label-group-state/group-expanded? group-id])]
      [:<>
       [ui/confirm-modal
        {:open?        @*show-delete-group-modal?
         :tr           tr
         :id           (str "delete-group-" group-id)
         :modal-title  (tr [:labels/confirm-delete-group])
         :on-yes-click (fn []
                         (>evt [::delete-label-group group-id])
                         (reset! *show-delete-group-modal? false))
         :on-close     #(reset! *show-delete-group-modal? false)}
        (tr [:labels/confirm-delete-group-body])]
       [:div.mb-2
        [label-ui/label-group-header
         {:tr          tr
          :group       {:id group-id :name group-name}
          :label-count (count labels)
          :expanded?   expanded?
          :on-toggle   #(>evt [::label-group-state/toggle-group-expanded group-id])
          :on-edit     #(>evt [::label-group-state/set-editing-group group-id group-name])
          :on-delete   #(reset! *show-delete-group-modal? true)}]
        (when expanded?
          [:div
           [:div.flex.flex-wrap
            (for-frag [label-entity labels]
              ^{:key (:db/id label-entity)}
              [deletable-label-chip
               {:tr             tr
                :label-entity   label-entity
                :existing-names existing-names}])]
           [new-label-input-connected {:tr             tr
                                       :group-id       group-id
                                       :existing-names existing-names}]])]])))

(defn add-group-form-connected
  "Add group form connected to re-frame state"
  [{:keys [tr authority-group-id group existing-names]}]
  (let [value           (<sub [::label-group-state/new-group-name])
        labels-enabled? (label-model/labels-enabled-for-group? group)]
    [label-ui/add-group-form
     {:tr             tr
      :value          value
      :existing-names existing-names
      :disabled?      (not labels-enabled?)
      :on-change      #(>evt [::label-group-state/set-new-group-name %])
      :on-save        #(>evt [::create-label-group authority-group-id value])
      :on-cancel      #(>evt [::label-group-state/cancel-adding-group])}]))

(defn group-name-edit-modal-connected
  "Group name edit modal connected to re-frame state"
  [{:keys [tr existing-names]}]
  (let [editing-id   (<sub [::label-group-state/editing-group-id])
        editing-name (<sub [::label-group-state/editing-group-name])
        open?        (some? editing-id)]
    [label-ui/group-name-edit-modal
     {:tr             tr
      :open?          open?
      :value          editing-name
      :existing-names existing-names
      :current-id     editing-id
      :on-change      #(>evt [::label-group-state/set-editing-group-name %])
      :on-save        #(>evt [::edit-label-group editing-id editing-name])
      :on-close       #(>evt [::label-group-state/cancel-editing-group])}]))

;;; =============================================================================
;;; Main View
;;; =============================================================================

(defn view [{:keys [tr]}]
  (let [authority-group     (<sub [::gas/group])
        authority-group-id  (:db/id authority-group)
        label-groups        (<sub [::label-group-state/label-groups authority-group-id])
        adding-group?       (<sub [::label-group-state/adding-group?])
        has-groups?         (seq label-groups)
        import-in-progress? (<sub [::label-file-transfer/import-in-progress?])
        export-in-progress? (<sub [::label-file-transfer/export-in-progress?])
        existing-names      (into {} (map (juxt label-model/label-group-name :db/id)) label-groups)]
    [acommon/section {}
     [:div.flex.flex-col.gap-4
      ;; Header with Add button and Export/Import
      [:div.flex.justify-between.items-center
       [:div.flex.gap-2
        (cc/button {:kind     :primary
                    :size     :default
                    :icon     i/plus
                    :on-click #(>evt [::label-group-state/start-adding-group])}
                   (tr [:labels/add-group]))]
       [:div.flex.gap-2.items-center
        [label-file-transfer/import-button
         {:tr             tr
          :context        (assoc label-file-transfer/inspection-context
                                 :parent-id-value authority-group-id)
          :existing-names existing-names
          :icon           i/upload
          :disabled?      import-in-progress?}]
        (cc/button {:kind     :tertiary
                    :size     :default
                    :icon     i/download
                    :disabled (or export-in-progress? (not has-groups?))
                    :on-click #(>evt [::label-file-transfer/open-export-modal])}
                   (tr [:labels/export-labels]))]]

      ;; Add group form
      (when adding-group?
        [add-group-form-connected {:tr                 tr
                                   :authority-group-id authority-group-id
                                   :group              authority-group
                                   :existing-names     existing-names}])

      ;; Label groups
      (if has-groups?
        (for-frag [group-entity label-groups]
          ^{:key (:db/id group-entity)}
          [label-group-section {:tr           tr
                                :group-entity group-entity}])
        [:div.text-gray-500.text-center.py-8
         (tr [:labels/no-groups])])

      ;; Edit group name modal
      [group-name-edit-modal-connected {:tr tr :existing-names existing-names}]

      ;; Export modal
      [label-file-transfer/export-modal {:tr           tr
                                         :label-groups label-groups
                                         :context      (assoc label-file-transfer/inspection-context
                                                              :parent-id-value authority-group-id)}]

      ;; Import conflict modal
      [label-file-transfer/import-conflict-modal {:tr      tr
                                                  :context (assoc label-file-transfer/inspection-context
                                                                  :parent-id-value authority-group-id)}]]]))
